"use client";

import { cn } from "@kyan/ui";
import { createPortal } from "react-dom";

import { Deposit } from "#/app/(desktop)/layouts/Header/components/Deposit/Deposit";
import { PortfolioRiskDropdown } from "#/app/(desktop)/layouts/Header/components/PortfolioRiskDropdown/PortfolioRiskDropdown";
import { WelcomeModal } from "#/app/(desktop)/layouts/Header/components/WelcomeModal/WelcomeModal";
import { Logo } from "#/components/Logo/Logo";
import { useTopBannerFeatureFlag } from "#/hooks/featureFlags/useTopBannerFeatureFlag";
import { useEoa } from "#/store/wallet/eoa/eoa";

import { Menu } from "./components/Menu/Menu";

export const Header: React.FC = () => {
  const { showTopBanner } = useTopBannerFeatureFlag();
  const { isEoaConnected } = useEoa();

  const headerContent = (
    <header
      className={cn(
        "bg-background border-divider fixed inset-0 bottom-auto flex h-16 min-h-16 border-b shadow-[0px_2px_14px_0px_rgba(201,201,201,0.50)] dark:shadow-none",
        {
          "top-18": showTopBanner,
        },
      )}
    >
      <div className="flex w-full items-center pl-4">
        <div className="border-divider flex h-full flex-1 items-center">
          <Logo showVersion={false} className="mr-4 h-6 w-5 min-w-5" />
          {isEoaConnected && (
            <>
              <PortfolioRiskDropdown />
              <WelcomeModal />
            </>
          )}
        </div>

        <div
          className={cn("flex h-full items-center justify-end gap-2", {
            "xs:px-4 justify-center sm:justify-end": isEoaConnected,
          })}
        >
          {isEoaConnected && <Deposit />}
          <Menu />
        </div>
      </div>
    </header>
  );

  if (typeof document !== "undefined") {
    return createPortal(headerContent, document.body);
  }

  return headerContent;
};
